import { useEffect, useMemo, useState, FC, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Modal, Mask } from 'antd-mobile';
import closeIcon from '@/assets/images/close_bai.png';
import text_title from '@/assets/images/text_title.png';
import iconHome from '@/assets/images/activity_l.png';
import icon_timer from '@/assets/images/icon_timer.png';
import jiangjin from '@/assets/images/jiangjin.svg';
import icon_btn from '@/assets/images/icon_btn.png';
import i_bai from '@/assets/images/i_bai.png';
import { getUserInfo } from '@/tools';
import { getLimitHours, getMoney, isCanJoin, remainInfo } from '@/api';
import { ActivationRemainData } from '@/api/interface';
import { initialInfo } from '../Activities/Retention';
import { useActivate, useUnactivate } from 'react-activation';
import { Toast } from 'antd-mobile';
// import { useActiveConfigList } from '@/store';
let firstRechargeInterval;

// 首充倒计时弹窗,改为跳转留存活动
const IconCountdown = ({ allConfigList }) => {
  const { getToken } = getUserInfo();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultTotalActivityHours = 24;
  const [totalSeconds, setTotalSeconds] = useState(
    defaultTotalActivityHours * 60 * 60
  ); // 初始总秒数，48小时
  // const [countdownSeconds, setCountdownSeconds] = useState(60);
  const [visible, setVisible] = useState(false);
  const [amounts, setAmounts] = useState<any>([]);
  const [isShow, setIsShow] = useState<any>(false);

  const [showRecharge, setShowRecharge] = useState(true);
  const [remainingSeconds, setRemainingSeconds] = useState(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const activityStartTime = new Date(userInfo.registerTime);
    const currentTime = new Date().getTime(); // 当前时间的时间戳
    const startTime = activityStartTime.getTime(); // 活动开始时间的时间戳
    const elapsedSeconds = Math.floor((currentTime - startTime) / 1000); // 已经过的秒数
    const remaining = defaultTotalActivityHours * 60 * 60 - elapsedSeconds;
    return remaining > 0 ? remaining : 0;
  });
  // const [activeStatus, setActiveStatus] = useState<any>({});
  // const [activeInfo, setActiveInfo] =
  //   useState<ActivationRemainData>(initialInfo);
  // const { joinStatus = 0, openStatus = 0 } = activeStatus;
  const isShowRedPoint = useMemo(
    () =>
      allConfigList.find(
        item => item.activityType === 'REMAIN' && item.showRedPoint
      ),
    [allConfigList]
  );

  // const allConfigList = useActiveConfigList(state => state?.allConfigList);

  // 查询能否参加留存活动
  const canJoin = async () => {
    const { code, data } = await isCanJoin();
    if (code === 200) {
      return data;
    } else {
      return {};
    }
  };

  //查询是否存在留存奖励
  const getRemainInfo = async () => {
    const { code, data } = await remainInfo();
    if (code === 200) {
      return data;
    } else {
      return {};
    }
  };
  const queryStatus = async () => {
    const [activeStatus, activeInfo] = await Promise.all([
      canJoin(),
      getRemainInfo()
    ]);
    const { joinStatus = 0, openStatus = 0 } = activeStatus as any;
    const { activationRemainAwardRecord } = activeInfo as any;
    let isShowRecharge = false;
    /* 第三图 登陆状态 活动已开始 且 有资格参与 且 无存款记录*/
    if (
      getToken() &&
      openStatus === 0 &&
      joinStatus === 1 &&
      !activationRemainAwardRecord
    ) {
      isShowRecharge = true;
    } else if (
      getToken() &&
      openStatus === 0 &&
      joinStatus === 2 &&
      activationRemainAwardRecord
    ) {
      /* 活动中-登录且已开启且 已参加 activationRemainAwardRecord有值*/
      isShowRecharge = true;
    }
    setIsShow(isShowRecharge);
  };

  useEffect(() => {
    if (getToken()) {
      queryStatus();
    }
  }, []);
  useActivate(() => {
    if (getToken()) {
      queryStatus();
    }
  });
  useActivate(() => {
    firstRechargeInterval = setInterval(() => {
      if (getToken()) {
        queryStatus();
      } else {
        if (firstRechargeInterval) clearInterval(firstRechargeInterval);
      }
    }, 10 * 1000);
    if (!getToken()) {
      if (firstRechargeInterval) clearInterval(firstRechargeInterval);
    }
  });

  useUnactivate(() => {
    if (firstRechargeInterval) clearInterval(firstRechargeInterval);
  });

  useEffect(() => {
    firstRechargeInterval = setInterval(() => {
      if (getToken()) {
        queryStatus();
      } else {
        if (firstRechargeInterval) clearInterval(firstRechargeInterval);
      }
    }, 10 * 1000);
    // if (!getToken()) {
    //   if (firstRechargeInterval) clearInterval(firstRechargeInterval);
    // }
    return () => clearInterval(firstRechargeInterval);
  }, []);

  const handleIconClick = () => {
    // 已登录就跳转留存活动
    if (getToken()) {
      const id = allConfigList.find(config => config.activityType == 'REMAIN')?.id
      if (id) {
        searchParams.set('activityId', id);
        navigate(`/promocao/retention?${searchParams}`);
      } else {
        Toast.show({ content: '活动不存在' })
      }
    } else {
      navigate(`/login/1?${searchParams}`);
    }
    // setVisible(true);
  };

  const handleCloseModal = () => {
    setVisible(false);
  };
  const goDeposito = () => {
    // navigate('/deposito');
    navigate(`/deposito?${searchParams}`);
  };

  const formatHourTime = seconds => {
    const hours = Math.floor(seconds / 3600);
    return `${hours}`;
  };
  const formatMinTime = seconds => {
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${minutes}`;
  };
  const formatSecTime = seconds => {
    const remainingSeconds = seconds % 60;
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
    return `${formattedSeconds}`;
  };

  return (
    (isShow || !getToken()) && (
      <>
        <div
          className="w-[86px] h-[86px] fixed bottom-[98px] left-4 z-5"
          onClick={handleIconClick}
        >
          <img src={iconHome} className="relative w-[86px] text-white" />
          {/* <div className="absolute w-[86px] h-[86px] leading-[86px] top-0 left-0 text-white text-[32px] font-semibold text-center"> */}
          {/* {countdownSeconds} */}
          {/* {!getToken() ? countdownSeconds : formatSecTime(remainingSeconds)} */}
          {/* </div> */}
          {isShowRedPoint && (
            <i className="w-3 h-3 rounded-full bg-[#EE0A24] absolute top-1 right-2" />
          )}
        </div>
        <Mask visible={visible} onMaskClick={() => setVisible(false)}>
          <div className="hdialog-content absolute top-1/3 left-2/4 bg-white w-[320px] pb-4 mt-[-160px] ml-[-160px] rounded-xl overflow-y-scroll">
            <div
              className="absolute w-8 right-[12px] top-[5px] flex justify-center align-center"
              onClick={handleCloseModal}
            >
              <img src={closeIcon} className="w-[24px] h-auto opacity-45" />
            </div>
            <div className="flex justify-center items-center flex-col">
              <div className="w-[263px] mt-5">
                <img src={text_title} className="w-full h-auto" />
              </div>
              <div className="relative w-[210px] h-[49px]">
                <img
                  src={icon_timer}
                  className="absolute w-full h-auto top-[0px] left-[0px]"
                />
                <div className="hdialog-timer-frame flex flex-row justify-center items-center w-full h-full">
                  <div className="hdialog-timer-value z-10 text-2xl">
                    {formatHourTime(remainingSeconds)}
                  </div>
                  <div className="hdialog-timer-title z-10 bg-[#FFF67F] w-5 h-5 flex justify-center items-center rounded mx-1">
                    h
                  </div>
                  <div className="hdialog-timer-value z-10 text-2xl">
                    {formatMinTime(remainingSeconds)}
                  </div>
                  <div className="hdialog-timer-title z-10 bg-[#FFF67F] w-5 h-5 flex justify-center items-center rounded mx-1">
                    min
                  </div>
                  <div className="hdialog-timer-value z-10 text-2xl">
                    {formatSecTime(remainingSeconds)}
                  </div>
                  <div className="hdialog-timer-title z-10 bg-[#FFF67F] w-5 h-5 flex justify-center items-center rounded mx-1">
                    S
                  </div>
                </div>
              </div>

              <div className="h-[100px]">
                <div className="w-[212px] h-[100px] border-2 border-[#FFEE00] rounded-xl mt-2">
                  <div className="h-6 flex justify-evenly items-center text-white/65 bg-[#ffffff26] rounded-tl rounded-tr">
                    <div>Depósitos</div>
                    <div className="border border-[#ffffff26] h-[20px]"></div>
                    <div>Bónus</div>
                  </div>
                  <div className="h-[70px]  overflow-y-scroll">
                    {amounts.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="h-6 flex justify-evenly items-center bg-[#ffffff0a]"
                        >
                          <div className="flex flex-1 justify-center items-center mt-1">
                            <span className="text-[#ffffff73] mr-1">R$</span>
                            <span className="text-[#ffffffd9] font-semibold">
                              {item.amount}
                            </span>
                          </div>
                          <div className="flex flex-1 justify-center items-center mt-1">
                            <img src={jiangjin} className="w-3 mr-1" />
                            <span className="text-[#FFEE00] font-semibold">
                              {item.giftAmt}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {/* <div className="w-[212px] h-[58px] border-2 border-[#FFEE00] rounded-xl mt-2">
                <div className="h-6 flex justify-evenly items-center text-white/65 bg-[#ffffff26] rounded-tl rounded-tr">
                  <div>Depósitos</div>
                  <div className="border border-[#ffffff26] h-[20px]"></div>
                  <div>Bónus</div>
                </div>
                <div className="h-6 flex justify-evenly items-center bg-[#ffffff0a]">
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <span className="text-[#ffffff73] mr-1">R$</span>
                    <span className="text-[#ffffffd9] font-semibold">10</span>
                  </div>
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <img src={jiangjin} className="w-3 mr-1" />
                    <span className="text-[#FFEE00] font-semibold">2</span>
                  </div>
                </div>
              </div>

              <div className="w-[212px] h-[58px] border-2 border-[#FFEE00] rounded-xl mt-2">
                <div className="h-6 flex justify-evenly items-center text-white/65 bg-[#ffffff26] rounded-tl rounded-tr">
                  <div>Depósitos</div>
                  <div className="border border-[#ffffff26] h-[20px]"></div>
                  <div>Bónus</div>
                </div>
                <div className="h-6 flex justify-evenly items-center bg-[#ffffff0a]">
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <span className="text-[#ffffff73] mr-1">R$</span>
                    <span className="text-[#ffffffd9] font-semibold">10</span>
                  </div>
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <img src={jiangjin} className="w-3 mr-1" />
                    <span className="text-[#FFEE00] font-semibold">2</span>
                  </div>
                </div>
              </div>

              <div className="w-[212px] h-[58px] border-2 border-[#FFEE00] rounded-xl mt-2">
                <div className="h-6 flex justify-evenly items-center text-white/65 bg-[#ffffff26] rounded-tl rounded-tr">
                  <div>Depósitos</div>
                  <div className="border border-[#ffffff26] h-[20px]"></div>
                  <div>Bónus</div>
                </div>
                <div className="h-6 flex justify-evenly items-center bg-[#ffffff0a]">
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <span className="text-[#ffffff73] mr-1">R$</span>
                    <span className="text-[#ffffffd9] font-semibold">10</span>
                  </div>
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <img src={jiangjin} className="w-3 mr-1" />
                    <span className="text-[#FFEE00] font-semibold">2</span>
                  </div>
                </div>
              </div>

              <div className="w-[212px] h-[58px] border-2 border-[#FFEE00] rounded-xl mt-2">
                <div className="h-6 flex justify-evenly items-center text-white/65 bg-[#ffffff26] rounded-tl rounded-tr">
                  <div>Depósitos</div>
                  <div className="border border-[#ffffff26] h-[20px]"></div>
                  <div>Bónus</div>
                </div>
                <div className="h-6 flex justify-evenly items-center bg-[#ffffff0a]">
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <span className="text-[#ffffff73] mr-1">R$</span>
                    <span className="text-[#ffffffd9] font-semibold">10</span>
                  </div>
                  <div className="flex flex-1 justify-center items-center mt-1">
                    <img src={jiangjin} className="w-3 mr-1" />
                    <span className="text-[#FFEE00] font-semibold">2</span>
                  </div>
                </div>
              </div> */}
              </div>

              <div
                className="relative w-[180px] h-[48px] mt-4"
                onClick={() => goDeposito()}
              >
                <img
                  src={icon_btn}
                  className="absolute w-full h-auto top-[0px] left-[0px]"
                />
                <div className="hdialog-timer-frame flex flex-row justify-center items-center w-full h-full">
                  <div className="z-10 text-sm text-white font-semibold">
                    Depósito Imediato
                  </div>
                </div>
              </div>
              <div className="w-[280px] h-[24px] flex justify-center items-center opacity-45 bg-[#ffffff14] rounded-xl mt-3">
                <img src={i_bai} className="w-[17px] ml-2 mr-2" />
                <span className="flex-1 text-[#ffffffa6]">
                  Descrição da Atividade
                </span>
              </div>
              <div className="px-6 text-[#ffffffa6] text-[12px] leading-4 h-[100px] overflow-y-auto pb-[10px]">
                <p className="leading-3 text-[#ffffffa6] mt-1">
                  1. Esta atividade só pode ser participada uma vez.
                </p>
                <p className="leading-3 text-[#ffffffa6] mt-1">
                  2. Antes da contagem regressiva terminar, a primeira recarga
                  receberá o bônus correspondente.
                </p>
                <p className="leading-3 text-[#ffffffa6] mt-1">
                  3. O uso do bônus deve seguir as regras da plataforma.
                </p>
                <p className="leading-3 text-[#ffffffa6] mt-1">
                  4. A empresa reserva-se o direito de interpretação final sobre
                  esta atividade.
                </p>
              </div>
            </div>
          </div>
        </Mask>
      </>
    )
  );
};
export default IconCountdown;
